import React, { Component } from 'react'

import config from '../../../../config'

import './style.scss'

export default class Home extends Component {
    renderHomepage = () => <div className={'text'}>{'Home sweet home'}</div>

    renderIFrameLoader = () => <div className={'loader'} />

    render() {
        return <div className={'home'}>{config.iframeSolution ? this.renderIFrameLoader() : this.renderHomepage()}</div>
    }
}
